var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
    _setup.operation?.operationData &&
    _setup.operation.operationData._id != '6746f70c439fbc9c810444fd'
  )?_c('div',{staticClass:"content_wrapper"},[_c(_setup.HeaderComponent,{tag:"HeaderView"}),_c('transition',{attrs:{"name":"fade"}},[_c(_setup.DynamicComponent,{tag:"component"})],1),_c(_setup.FooterComponent,{tag:"FooterView"})],1):_c('div',{staticClass:"text-center py-48"},[_vm._v("Maintenance en cours")])
}
var staticRenderFns = []

export { render, staticRenderFns }